import { GlobalStyles as MuiGlobalStyles, type GlobalStylesProps as MuiGlobalStylesProps } from '@mui/material'

export type GlobalStylesProps = MuiGlobalStylesProps

export const GlobalStyles = MuiGlobalStyles
